import React, {useEffect, useRef} from "react";
import { Line } from "react-chartjs-2";
import ReactTooltip from "react-tooltip";

const LineChart = ({ chartName, chartNameTooltip, labels, values, width, height, pointBorderColor, borderColor, borderWidth, pointRadius, xAxisLabel, yAxisLabel, showBorder }) => {

  const chartRef = useRef(null);

  // console.debug("values------", values, labels)

  let data = {
    labels: values && values.length ? labels.slice(0, -1) : [],
    datasets: [
      {
        label: "Data",
        data: values.map(ele => {
          return ele.value;
        }),
        fill: false,
        clip: true,
        tension: 0.2,
        borderWidth: borderWidth ? borderWidth : 1,
        borderColor: borderColor ? borderColor : "lightgray",
        pointBorderColor: pointBorderColor ? pointBorderColor : 'lightgray',
        pointRadius: pointRadius ? pointRadius : 4,
        pointBackgroundColor: values.map(ele => {
          return ele?.color
        }), 
      },
    ],
  };


  const moveScroll = () => {
    const chart = chartRef.current;
    const {
      ctx,
      canvas,
      chartArea: { top, right, bottom, left, width, height },
      scales: {x, y},
    } = chart;

    canvas.addEventListener('click', (event) => {


      const rect = canvas.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const radius = 8;

      if (x >= left - radius && x <= left + radius &&
        y >= height / 2 + top - radius && y <= height / 2 + top + radius) {
          chart.options.scales.x.min = chart.options.scales.x.min - 1
          chart.options.scales.x.max = chart.options.scales.x.max - 1

          if (chart.options.scales.x.min <= 0) {
            chart.options.scales.x.min = 0
            chart.options.scales.x.max = 10
          }
      } else if (x >= right - radius && x <= right + radius &&
        y >= height / 2 + top - radius && y <= height / 2 + top + radius) {
          chart.options.scales.x.min = chart.options.scales.x.min + 1
          chart.options.scales.x.max = chart.options.scales.x.max + 1
          if (chart.options.scales.x.max >= data.datasets[0].data.length) {
            chart.options.scales.x.min = data.datasets[0].data.length - 10
            chart.options.scales.x.max = data.datasets[0].data.length
          }
      }


      chart.update();
    })
  }

  console.debug("chartNamechartName", chartName)

  useEffect(() => {
    moveScroll()
  }, [])

  const moveChart = {
    id: "moveChart",

    afterDatasetsDraw(chart, args, pluginOptions) {
      const {
        ctx, 
        data,
        canvas,
        chartArea: { top, right, bottom, left, width, height },
      } = chart;

      const angle = Math.PI / 180

      class CircleChevron {
        draw(ctx, x1, pixel, radius) {
          // circle
          ctx.beginPath();
          ctx.lineWidth = 3;
          ctx.strokeStyle = 'rgba(102, 102, 102, 0.5)';
          ctx.fillStyle = 'white';
          ctx.arc(x1, height/2 + top, radius, angle * 0, angle * 360, false);
          ctx.stroke();
          ctx.fill();
          ctx.closePath();

          // chevron arrow
          ctx.beginPath();
          ctx.lineWidth = 2;
          ctx.strokeStyle = '#741a76';
          ctx.moveTo(x1 + pixel, height/2 + top - 4);
          ctx.lineTo(x1 - pixel, height/2 + top);
          ctx.lineTo(x1 + pixel, height/2 + top + 4);
          ctx.stroke();
          ctx.closePath();
        }
      }

      let radius = 8;
      if (data?.labels?.length) {
        if (chart.options.scales.x.min > 0) {
          let drawCircleLeft = new CircleChevron();
          drawCircleLeft.draw(ctx, left, 4, radius);
        }
          
          
        if (chart.options.scales.x.max < data.datasets[0].data.length) {
          let drawCircleRight = new CircleChevron();
          drawCircleRight.draw(ctx, right, -4, radius);
        }
      }

    }
  }

  const chartAreaBorder = {
    id: 'chartAreaBorder',
    beforeDraw(chart, args, options) {
      const {ctx, chartArea: {left, top, width, height}} = chart;
      ctx.save();
      ctx.strokeStyle = options.borderColor;
      ctx.lineWidth = options.borderWidth;
      ctx.strokeRect(left, top, width, height);
      ctx.restore();
    }
  };

  const emptyChart = {
    id: 'emptyChart',
    afterDatasetsDraw: chart => {
      const { ctx, config, data, canvas, chartArea: { top, bottom, left, right, width, height }, scales: { x, y } } = chart;
      // console.debug("values============", data)
      if (data?.labels?.length === 0) {
        ctx.save();
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.font = "12px Arial";
        ctx.fillStyle = "gray";
        ctx.fillText('No data available', width/1.25, height/2);
        ctx.restore();
      }
    }
  };

  return (
    <div>
      <div style={{
          textAlign: "center",
          fontWeight: 600,
          fontSize: "14px",
          color: "#666666",
        }}>
      {chartName}
      <span 
          data-tip={chartNameTooltip}
          style={{
            display: chartName ? 'block' : 'none'
          }}
          className="d-inline"
          data-for='linechart_index_tooltip'>
          <i className="fa-solid fa-circle-info ml-2 text-secondary" ></i>
        </span>
      <ReactTooltip id='linechart_index_tooltip' place='right' effect="float" className='tool-tip tooltip-css'/>
      </div>
      <Line
        ref={chartRef} 
        title={chartName}
        width={width}
        height={height}
        plugins={[moveChart, emptyChart]}
        data={data}
      
        options={{
          spanGaps: true,
          responsive: true,
          clip: false,

          plugins: {
            chartAreaBorder: {
              borderColor: '#484848',
              borderWidth: showBorder ? 1 :  0,
            },
            legend: {
              display: false,
            },
            tooltip: {
              xAlign: "left",
              displayColors: false,
              bodyAlign: "center",
              callbacks: {
                title: function(context) {
                  let quizName = null;
                  if (context.length) {
                    let index = context[0].dataIndex;
                    quizName = values[index].quizName
                  }
                  
                  return quizName
                },
                
                label: function (context) {
                  return `${parseInt(context.formattedValue, 10)}`;
                },
              },
              // enabled: true,
            },
          },
          scales: {
            x: {
              offset: true,
              padding: 10,
              title:{
                display: true,
                text: xAxisLabel ? xAxisLabel : "Attempt #",
                font: {
                  weight: 700,
                }
              },
              min: values ? values.length - 10: 0,
              max: values ? values.length : 10,
              grid: {
                  display:false
              },
            },
            y: {
              offset: true,
              title: {
                display: true,
                text: yAxisLabel ? yAxisLabel : "",
                font: {
                  weight: 700,
                }
              },
              type: (chartName === 'Time' || chartName === 'Time per Question Over Time')  ? 'logarithmic' :'linear',
              beginAtZero: true,
              min: (chartName === 'Time' || chartName === 'Time per Question Over Time')  ? null : 0,
              max: (chartName === 'Time' || chartName === 'Time per Question Over Time')  ? null : 100,
              grid : {
                  display: false
              },
              ticks: {
                stepSize: 10,
              }
            }
          }
        }}
      />
    </div>
  );
};

export default LineChart;
